import afterLoginApiAxios from "../../../Util/API Calls/afterLogin";
import { LOCALSTORAGEKEY } from "../../../Util/Helper/localStorageUtils";

export const getPastVisitVitals = async (params, api) => {
  const res = await afterLoginApiAxios({
    method: "get",
    url: api,
    params: params,
    headers: {
      authorization: localStorage.getItem(LOCALSTORAGEKEY.ID_TOKEN),
    },
  });

  if (res) {
    return [res, false];
  }
  return [null, true]; // [response, error]
};

export const getPatientVitals = async (payload, api) => {
  const res = await afterLoginApiAxios({
    method: "post",
    url: api,
    data: payload,
    headers: {
      authorization: localStorage.getItem(LOCALSTORAGEKEY.ID_TOKEN),
    },
  });

  if (res) {
    return [res, false];
  }
  return [null, true]; // [response, error]
};

export const addEditVitalsApi = async (payload, api) => {
  const res = await afterLoginApiAxios({
    method: "post",
    url: api,
    data: payload,
    headers: {
      authorization: localStorage.getItem(LOCALSTORAGEKEY.ID_TOKEN),
    },
  });

  if (res) {
    return [res, false];
  }
  return [null, true]; // [response, error]
};

export const getSavedTemplates = async (payload, api) => {
  const res = await afterLoginApiAxios({
    method: "post",
    url: api,
    data: payload,
    headers: {
      authorization: localStorage.getItem(LOCALSTORAGEKEY.ID_TOKEN),
    },
  });

  if (res) {
    return [res, false];
  }
  return [null, true]; // [response, error]
};

export const getPastConsultations = async (payload, api) => {
  const res = await afterLoginApiAxios({
    method: "post",
    url: api,
    data: payload,
    headers: {
      authorization: localStorage.getItem(LOCALSTORAGEKEY.ID_TOKEN),
    },
  });

  if (res) {
    return [res, false];
  }
  return [null, true]; // [response, error]
};

export const getManualRx = async (payload, api) => {
  const res = await afterLoginApiAxios({
    method: "post",
    url: api,
    data: payload,
    headers: {
      authorization: localStorage.getItem(LOCALSTORAGEKEY.ID_TOKEN),
    },
  });

  if (res) {
    return [res, false];
  }
  return [null, true]; // [response, error]
};

export const getPreviousPrescription = async (payload, api) => {
  const res = await afterLoginApiAxios({
    method: "post",
    url: api,
    data: payload,
    headers: {
      authorization: localStorage.getItem(LOCALSTORAGEKEY.ID_TOKEN),
    },
  });

  if (res) {
    return [res, false];
  }
  return [null, true]; // [response, error]
};

// ------------- SAVED AND SHARED -------------- //
export const getSharedEPrescriptions = async (payload, api) => {
  const res = await afterLoginApiAxios({
    method: "post",
    url: api,
    data: payload,
    headers: {
      authorization: localStorage.getItem(LOCALSTORAGEKEY.ID_TOKEN),
    },
  });

  if (res) {
    return [res, false];
  }
  return [null, true]; // [response, error]
};

export const getSavedEPrescriptions = async (payload, api) => {
  const res = await afterLoginApiAxios({
    method: "post",
    url: api,
    data: payload,
    headers: {
      authorization: localStorage.getItem(LOCALSTORAGEKEY.ID_TOKEN),
    },
  });

  if (res) {
    return [res, false];
  }
  return [null, true]; // [response, error]
};
// -------------------------------------------------------//

export const getPatientDetails = async (payload, api) => {
  const res = await afterLoginApiAxios({
    method: "post",
    url: api,
    data: payload,
    headers: {
      authorization: localStorage.getItem(LOCALSTORAGEKEY.ID_TOKEN),
    },
  });

  if (res) {
    return [res, false];
  }
  return [null, true]; // [response, error]
};

export const updatePatientDetails = async (payload, api) => {
  const res = await afterLoginApiAxios({
    method: "post",
    url: api,
    data: payload,
    headers: {
      authorization: localStorage.getItem(LOCALSTORAGEKEY.ID_TOKEN),
    },
  });

  if (res) {
    return [res, false];
  }
  return [null, true]; // [response, error]
};

export const getDocuments = async (payload, api) => {
  const res = await afterLoginApiAxios({
    method: "post",
    url: api,
    data: payload,
    headers: {
      authorization: localStorage.getItem(LOCALSTORAGEKEY.ID_TOKEN),
    },
  });

  if (res) {
    return [res, false];
  }
  return [null, true]; // [response, error]
};

export const deleteDocument = async (payload, api) => {
  const res = await afterLoginApiAxios({
    method: "post",
    url: api,
    data: payload,
    headers: {
      authorization: localStorage.getItem(LOCALSTORAGEKEY.ID_TOKEN),
    },
  });

  if (res) {
    return [res, false];
  }
  return [null, true]; // [response, error]
};

export const getMedicalTermList = async (api, params) => {
  const res = await afterLoginApiAxios({
    method: "get",
    params: params,
    url: api,
    headers: {
      authorization: localStorage.getItem(LOCALSTORAGEKEY.ID_TOKEN),
    },
  });

  if (res) {
    if (res?.data?.statusCode === 200) {
      if (res?.data?.data?.length > 0) {
        res.data.data.forEach((data) => {
          data["label"] = data?.title;
          data["value"] = data?.title;
          data["showPainScale"] = false;
          data["painScaleData"] = { title: data?.title };
        });
      }
      return [res?.data?.data, res?.data?.total_count, false];
    }
    return [[], 0, false];
  }
  return [null, true]; // [response, error]
};

export const getDiagnosisList = async (api, params) => {
  const res = await afterLoginApiAxios({
    method: "get",
    params: params,
    url: api,
    headers: {
      authorization: localStorage.getItem(LOCALSTORAGEKEY.ID_TOKEN),
    },
  });

  if (res) {
    if (res?.data?.statusCode === 200) {
      if (res?.data?.data?.length > 0) {
        res.data.data.forEach((data) => {
          data["label"] = data?.title;
          data["value"] = data?.title;
        });
      }
      return [res?.data?.data, res?.data?.total_count, false];
    }
    return [[], false];
  }
  return [null, true]; // [response, error]
};

export const getErxTemplateData = async (payload, api) => {
  const res = await afterLoginApiAxios({
    method: "post",
    url: api,
    data: payload,
    headers: {
      authorization: localStorage.getItem(LOCALSTORAGEKEY.ID_TOKEN),
    },
  });

  if (res) {
    return [res, false];
  }
  return [null, true]; // [response, error]
};

export const getPrescriptionId = async (payload, api) => {
  const res = await afterLoginApiAxios({
    method: "post",
    url: api,
    data: payload,
    headers: {
      authorization: localStorage.getItem(LOCALSTORAGEKEY.ID_TOKEN),
    },
  });

  if (res) {
    return [res, false];
  }
  return [null, true]; // [response, error]
};

export const getPrescriptionData = async (payload, api) => {
  const res = await afterLoginApiAxios({
    method: "post",
    url: api,
    data: payload,
    headers: {
      authorization: localStorage.getItem(LOCALSTORAGEKEY.ID_TOKEN),
    },
  });

  if (res) {
    return [res, false];
  }
  return [null, true]; // [response, error]
};

export const updateFollowDate = async (payload, api) => {
  const res = await afterLoginApiAxios({
    method: "post",
    url: api,
    data: payload,
    headers: {
      authorization: localStorage.getItem(LOCALSTORAGEKEY.ID_TOKEN),
    },
  });

  if (res) {
    return [res, false];
  }
  return [null, true]; // [response, error]
};

export const addUpdatePrescriptionData = async (payload, api, method) => {
  const res = await afterLoginApiAxios({
    method: method,
    url: api,
    data: payload,
    headers: {
      authorization: localStorage.getItem(LOCALSTORAGEKEY.ID_TOKEN),
    },
  });

  if (res) {
    return [res, false];
  }
  return [null, true]; // [response, error]
};

export const getReportList = async (api, params) => {
  const res = await afterLoginApiAxios({
    method: "get",
    params: params,
    url: api,
    headers: {
      authorization: localStorage.getItem(LOCALSTORAGEKEY.ID_TOKEN),
    },
  });

  if (res) {
    if (res?.data?.statusCode === 200) {
      if (res?.data?.data?.length > 0) {
        res.data.data.forEach((data) => {
          data["label"] = data?.title;
          data["value"] = data?.title;
        });
      }
      return [res?.data?.data, res?.data?.total_count, false];
    }
    return [[], 0, false];
  }
  return [null, true]; // [response, error]
};
export const investigationAndNotesSearch = async (api, params) => {
  const res = await afterLoginApiAxios({
    method: "get",
    params: params,
    url: api,
    headers: {
      authorization: localStorage.getItem(LOCALSTORAGEKEY.ID_TOKEN),
    },
  });

  if (res) {
    if (res?.data?.statusCode === 200) {
      if (res?.data?.data?.length > 0) {
        res.data.data.forEach((data) => {
          data["label"] = data?.title;
          data["value"] = data?.title;
        });
      }
      return [res?.data?.data, res?.data?.total_count, false];
    }
    return [[], 0, false];
  }
  return [null, true]; // [response, error]
};

export const getDoctorNotes = async (id, params) => {
  let api = `/api/v1/prescription/${id}/prescription-notes`;
  const res = await afterLoginApiAxios({
    method: "get",
    params: params,
    url: api,
    headers: {
      authorization: localStorage.getItem(LOCALSTORAGEKEY.ID_TOKEN),
    },
  });

  if (res) {
    if (res?.data?.statusCode === 200) {
      return [res?.data?.data, res?.data?.total_count, false];
    }
    return [[], 0, false];
  }
  return [null, 0, true]; // [response, error]
};
export const getUserSettings = async (api) => {
  const res = await afterLoginApiAxios({
    method: "get",
    url: api,
    headers: {
      authorization: localStorage.getItem(LOCALSTORAGEKEY.ID_TOKEN),
    },
  });

  if (res) {
    return [res, false];
  }
  return [null, true]; // [response, error]
};

export const updateUserSettings = async (payload, api) => {
  const res = await afterLoginApiAxios({
    method: "post",
    url: api,
    data: payload,
    headers: {
      authorization: localStorage.getItem(LOCALSTORAGEKEY.ID_TOKEN),
    },
  });

  if (res) {
    return [res, false];
  }
  return [null, true]; // [response, error]
};

export const getGetDrugsData = async (api, params) => {
  const res = await afterLoginApiAxios({
    method: "get",
    url: api,
    params: params,
    headers: {
      authorization: localStorage.getItem(LOCALSTORAGEKEY.ID_TOKEN),
    },
  });
  if (res) {
    if (res?.data?.statusCode === 200) {
      return [res?.data, false];
    }
    return [[], false];
  }
  return [null, true]; // [response, error]
};

export const getDrugForAutoFill = async (api, payload) => {
  const res = await afterLoginApiAxios({
    method: "post",
    url: api,
    data: payload,
    headers: {
      authorization: localStorage.getItem(LOCALSTORAGEKEY.ID_TOKEN),
    },
  });
  if (res) {
    if (res?.data?.statusCode === 200) {
      return [res, false];
    }
    return [[], false];
  }
  return [null, true]; // [response, error]
};

export const deleteDoctorAddedDrug = async (api, payload) => {
  const res = await afterLoginApiAxios({
    method: "post",
    url: api,
    data: payload,
    headers: {
      authorization: localStorage.getItem(LOCALSTORAGEKEY.ID_TOKEN),
    },
  });
  if (res) {
    if (res?.data?.statusCode === 200) {
      return [res, false];
    }
    return [null, false];
  }
  return [null, true]; // [response, error]
};

export const getVaccineChart = async (api, params) => {
  const res = await afterLoginApiAxios({
    method: "get",
    url: api,
    params: params,
    headers: {
      authorization: localStorage.getItem(LOCALSTORAGEKEY.ID_TOKEN),
    },
  });
  if (res) {
    if (res?.data?.statusCode === 200) {
      return [res?.data, false];
    }
    return [null, false];
  }
  return [null, true]; // [response, error]
};

export const addUpdateVaccineChart = async (api, payload) => {
  const res = await afterLoginApiAxios({
    method: "post",
    url: api,
    data: payload,
    headers: {
      authorization: localStorage.getItem(LOCALSTORAGEKEY.ID_TOKEN),
    },
  });
  if (res) {
    if (res?.data?.statusCode === 200) {
      return [res, false];
    }
    return [null, true];
  }
  return [null, true]; // [response, error]
};

export const approveAndShareRxData = async (payload, api) => {
  const res = await afterLoginApiAxios({
    method: "post",
    url: api,
    data: payload,
    headers: {
      authorization: localStorage.getItem(LOCALSTORAGEKEY.ID_TOKEN),
    },
  });
  if (res) {
    if (res?.data?.statusCode === 200) {
      return [res, false];
    }
    return [null, true];
  }
  return [null, true]; // [response, error]
};

export const printGrowChartPDF = async (api, payload) => {
  const res = await afterLoginApiAxios({
    method: "post",
    url: api,
    data: payload,
    headers: {
      authorization: localStorage.getItem(LOCALSTORAGEKEY.ID_TOKEN),
    },
  });
  if (res) {
    if (res?.data?.statusCode === 200) {
      return [res, false];
    }
    return [null, true];
  }
  return [null, true];
};

export const saveCustomDataInDB = async (api, payload) => {
  const res = await afterLoginApiAxios({
    method: "post",
    url: api,
    data: payload,
    headers: {
      authorization: localStorage.getItem(LOCALSTORAGEKEY.ID_TOKEN),
    },
  });
  if (res) {
    if (res?.data?.statusCode === 200) {
      return [res, false];
    }
    return [null, true];
  }
  return [null, true]; // [response, error]
};

export const getPatientHistorySuggestion = async (api) => {
  const res = await afterLoginApiAxios({
    method: "get",
    url: api,
    headers: {
      authorization: localStorage.getItem(LOCALSTORAGEKEY.ID_TOKEN),
    },
  });
  if (res) {
    if (res?.data?.statusCode === 200) {
      return [res, false];
    }
    return [null, true];
  }
  return [null, true]; // [response, error]
};

export const getDrugsSuggestions = async (api) => {
  const res = await afterLoginApiAxios({
    method: "get",
    url: api,
    headers: {
      authorization: localStorage.getItem(LOCALSTORAGEKEY.ID_TOKEN),
    },
  });

  if (res) {
    return [res, false];
  }
  return [null, true]; // [response, error]
};

export const getInstructionSuggestion = async (api) => {
  const res = await afterLoginApiAxios({
    method: "get",
    url: api,
    headers: {
      authorization: localStorage.getItem(LOCALSTORAGEKEY.ID_TOKEN),
    },
  });
  if (res) {
    if (res?.data?.statusCode === 200) {
      return [res, false];
    }
    return [null, true];
  }
  return [null, true]; // [response, error]
};

export const getDrugInstructionList = async (api, params) => {
  const res = await afterLoginApiAxios({
    method: "get",
    url: api,
    params: params,
    headers: {
      authorization: localStorage.getItem(LOCALSTORAGEKEY.ID_TOKEN),
    },
  });
  if (res) {
    if (res?.data?.statusCode === 200) {
      return [res, false];
    }
    return [[], false];
  }
  return [null, true]; // [response, error]
};

export const getPrescriptionForPreviewAPICall = async (api, payload) => {
  const res = await afterLoginApiAxios({
    method: "post",
    url: api,
    data: payload,
    headers: {
      authorization: localStorage.getItem(LOCALSTORAGEKEY.ID_TOKEN),
    },
  });
  if (res) {
    if (res?.data?.statusCode === 200) {
      return [res, false];
    }
    return [[], false];
  }
  return [null, true]; // [response, error]
};

export const getPrescriptionPreview = async (payload, url) => {
  const res = await afterLoginApiAxios({
    method: "post",
    url: url,
    data: payload,
    headers: {
      authorization: localStorage.getItem(LOCALSTORAGEKEY.ID_TOKEN),
    },
  });
  if (res) {
    return [res, false];
  }
  return [null, true]; // [response, error]
};

export const getPrescriptionPdf = async (payload, url) => {
  const res = await afterLoginApiAxios({
    method: "post",
    url: url,
    data: payload,
    headers: {
      authorization: localStorage.getItem(LOCALSTORAGEKEY.ID_TOKEN),
    },
  });
  if (res) {
    return [res, false];
  }
  return [null, true]; // [response, error]
};

export const saveTemplate = async (api, payload) => {
  const res = await afterLoginApiAxios({
    method: "post",
    url: api,
    data: payload,
    headers: {
      authorization: localStorage.getItem(LOCALSTORAGEKEY.ID_TOKEN),
    },
  });
  if (res) {
    if (res?.data?.statusCode === 200) {
      return [res, false];
    }
    return [[], false];
  }
  return [null, true]; // [response, error]
};

export const deleteSavedTemplate = async (api, payload) => {
  const res = await afterLoginApiAxios({
    method: "post",
    url: api,
    data: payload,
    headers: {
      authorization: localStorage.getItem(LOCALSTORAGEKEY.ID_TOKEN),
    },
  });
  if (res) {
    if (res?.data?.statusCode === 200) {
      return [res, false];
    }
    return [[], false];
  }
  return [null, true]; // [response, error]
};

export const getSectionTemplateList = async (api) => {
  const res = await afterLoginApiAxios({
    method: "get",
    url: api,
    headers: {
      authorization: localStorage.getItem(LOCALSTORAGEKEY.ID_TOKEN),
    },
  });
  if (res) {
    if (res?.data?.statusCode === 200) {
      return [res, false];
    }
    return [[], false];
  }
  return [null, true]; // [response, error]
};

export const createSectionTemplate = async (api, payload) => {
  const res = await afterLoginApiAxios({
    method: "post",
    url: api,
    data: payload,
    headers: {
      authorization: localStorage.getItem(LOCALSTORAGEKEY.ID_TOKEN),
    },
  });
  if (res) {
    if (res?.data?.statusCode === 200) {
      return [res, false];
    }
    return [[], false];
  }
  return [null, true]; // [response, error]
};

export const deleteSavedSectionTemplate = async (api) => {
  const res = await afterLoginApiAxios({
    method: "delete",
    url: api,
    headers: {
      authorization: localStorage.getItem(LOCALSTORAGEKEY.ID_TOKEN),
    },
  });
  if (res) {
    if (res?.data?.statusCode === 200) {
      return [res, false];
    }
    return [[], false];
  }
  return [null, true]; // [response, error]
};
